import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";

import CloseIcon from "../Common/CloseIcon";
import { I18n } from "@aws-amplify/core";
import Button from '@material-ui/core/Button';

import images from "../../assets/img/images";
import { fetchGet } from "../../api/fetch";


const styles = {
    container: {
        width: 367,
        height: 250
    },
    close: {
        float: "right",
        margin: 10,
        display: "inline",
    },
    warning: {
        right: -180,
        top: 80,
        color: "red"
    },
    warningMessage: {
        top: 100,
        left: 45,
        width: "280px",
    },
    buttons: {
        display: "table",
        margin: "0 auto",
        left: 30,
        top: 152
    }
};

const ZoneDelete = withStyles(styles)((props) => {
    const {
        classes,
        handleClose,
        currentZoneID,
        currentNode,
        setEdit,
        goTo,
        setTreeDirty
    } = props;

    const [error, setError] = React.useState(false)

    async function processRequest() {
        try {
            setEdit(false)
            await fetchGet(
                `vmi/zones/deactivate/${currentZoneID}`
            );

            setTreeDirty(true);
            goTo(currentNode["parent_zone_id"]);

            handleClose(false)
        } catch (error) {
            console.log(error)
            setError(true)
        }

    }

    return (
        <div className={classes.container}>
            <div className={classes.close}>
                <CloseIcon closeFunction={handleClose} />
            </div>
            <div style={{ height: 0 }}>
                <img src={images.deleteWarningTriangle} className={classes.warning} alt="warning"></img><br />
                <div className={classes.warningMessage}>{!error ? I18n.get("zone_delete") : I18n.get("order_in_progress_warning")}</div>
            </div>

            {!error ?
            <div className={classes.buttons}>
                <Button onClick={() => { handleClose() }} color="primary">
                    {I18n.get("site_cancel")}
                </Button>
                <Button onClick={() => { processRequest() }} style={{ top: "-4px", left: "14px" }} variant="contained" color="primary">
                    {I18n.get("delete")}
                </Button>
            </div>
            : null }


        </div>
    );

});

export default withRouter(ZoneDelete);
